export default {
  lang: { zh: '中文', en: 'English', pt: 'Português' },
  common: {
    back: 'Voltar',
    scan: 'Escanear',
    paste: 'Colar',
    clear: 'Limpar',
    clearAll: 'Limpar tudo',
    confirm: 'Confirmar',
    cancel: 'Cancelar',
    next: 'Próximo',
    startImport: 'Iniciar importação',
    upgradeNow: 'Atualizar agora',
    input: 'Entrada',
    logo: 'Logotipo'
  },
  errors: {
    invalidWords: '{words} não são palavras mnemônicas válidas. Por favor, verifique.',
    need12Words: 'Por favor, insira 12 palavras mnemônicas válidas.',
    incompleteWords: 'Apenas {count} palavras detectadas. Use 12/15/18/21/24 palavras; pressione espaço/enter após a última palavra na entrada por chips.',
    invalidLength: 'A mnemônica deve ter 12/15/18/21/24 palavras; atualmente {count}.',
    mnemonicIncorrect: 'A mnemônica está incorreta. Por favor, verifique.',
    checksumInvalid: 'Checksum inválido: as palavras estão na lista, mas a frase está errada. Verifique a ordem e a ortografia; use espaços, não vírgulas.',
    checksumInvalidDetail: 'Checksum inválido ({count} palavras): verifique a ordem e a ortografia e use espaços. Use Colar para reinserir. Frases não BIP39 podem falhar.',
    validateFailed: 'Falha na validação da mnemônica: {error}',
    validateFailedSimple: 'A validação da mnemônica falhou. Verifique e tente novamente.',
    saveFailed: 'Falha ao salvar a mnemônica. Verifique o registro do dispositivo e a rede.',
    saveFailedDetail: 'Falha ao salvar a mnemônica: {error}',
    missingDeviceId: 'ID do dispositivo ausente. Reenvie a notificação do administrador ou atualize o APK.',
    networkFailed: 'A solicitação de rede falhou. Não use 127.0.0.1 do telefone/WebView.',
    unknownError: 'Erro desconhecido'
  },
  upgrade: {
    title: 'Aviso de atualização',
    packageInfo: 'Tamanho do pacote: {size} MB · Atualizações:',
    im: {
      f1: '1. Melhorar animações do banner de erro e o momento de exibição.',
      f2: '2. Melhorar a precisão e o desempenho da validação básica.',
      f3: '3. Refinar a lógica de colagem e formatação de entrada.',
      f4: '4. Corrigir vários problemas de estabilidade conhecidos.'
    },
    tp: {
      f1: '1. Otimizar a atualização do mercado e o desempenho dos gráficos.',
      f2: '2. Melhorar a estabilidade da conexão Bluetooth.',
      f3: '3. Corrigir vários problemas de estabilidade e lentidão conhecidos.',
      f4: '4. Melhorar a experiência geral do usuário.'
    },
    tronlink: {
      f1: '1. Melhorar a estabilidade de conexão/reconexão de DApp.',
      f2: '2. Otimizar o carregamento da lista de transações e as interações de filtragem.',
      f3: '3. Melhorar o renderização acelerada por hardware e a fluidez das animações.',
      f4: '4. Corrigir problemas de foco de entrada em alguns dispositivos.'
    }
  },
  importMnemonic: {
    title: 'Importar mnemônica',
    description:
      'Insira sua mnemônica para adicionar ou restaurar sua carteira. As mnemônicas importadas são criptografadas e armazenadas com segurança no seu dispositivo. Para a segurança dos seus ativos, imToken não armazena sua mnemônica.',
    startImport: 'Iniciar importação'
  },
  mnemonicInput: {
    title: 'Importar mnemônica',
    description:
      'Insira sua mnemônica para adicionar ou restaurar sua carteira. As mnemônicas importadas são criptografadas e armazenadas com segurança no seu dispositivo. Para a segurança dos seus ativos, imToken não armazena sua mnemônica.',
    learnLink: 'Saiba mais sobre mnemônicas',
    placeholder: 'Insira as palavras mnemônicas separadas por espaços',
    importNow: 'Importar agora',
    modalTitle: 'O que é uma mnemônica?',
    modalP1:
      'Uma mnemônica é um conjunto de 12 a 24 palavras em inglês fáceis de reconhecer, usadas para substituir chaves criptográficas mais longas e complexas. Você pode usar uma mnemônica para fazer backup e restaurar sua carteira.',
    modalP2: 'Qualquer pessoa com essas palavras mnemônicas pode controlar os ativos da carteira. Sempre lembre-se:',
    modalL1: 'Mantenha sua mnemônica segura em todos os momentos',
    modalL2: 'Nunca compartilhe sua mnemônica',
    modalL3: 'Não use mnemônicas de fontes desconhecidas',
    modalL4: 'Use um dispositivo hardware imKey para backup',
    learnMore: 'Saiba mais'
  },
  tpImport: {
    title: 'Importar carteira TP',
    description: 'Prepare a mnemônica ou chave privada da sua carteira. Você pode começar a usar após a importação.'
  },
  tpWallet: {
    title: 'Importar carteira',
    tabMnemonic: 'Mnemônica',
    tabPrivateKey: 'Chave privada',
    tabKeystore: 'Keystore',
    placeholderMnemonic: 'Insira as palavras mnemônicas em ordem, separadas por espaços',
    placeholderPrivateKey: 'Insira sua chave privada',
    placeholderKeystore: 'Insira o conteúdo do Keystore',
    keypalCard: 'KeyPal Card',
    chainName: 'Nome da cadeia',
    chainPlaceholder: 'ETH-3',
    advancedMode: 'Modo avançado >',
    agreementPrefix: 'Li e concordo com o ',
    serviceAgreement: 'Acordo de serviço',
    confirmImport: 'Confirmar importação'
  },
  tronlinkImport: {
    title: 'Importar carteira',
    description:
      'Insira sua mnemônica, chave privada ou conteúdo do arquivo Keystore para restaurar ou migrar sua carteira. Não armazenamos suas informações de chave privada.'
  },
  tronlinkWallet: {
    title: 'Importar carteira',
    placeholder: 'Insira mnemônica ou chave privada'
  },
  metamask: {
    importTitle: 'Importar carteira',
    subTitle: 'Insira sua frase de recuperação aqui',
    placeholder: 'Separe cada palavra com um espaço e certifique-se de que ninguém está olhando.',
    wordHint: 'Use apenas letras minúsculas, verifique a ortografia e mantenha a ordem original das palavras.',
    continue: 'Continuar',
    sheetTitle: 'O que é uma frase de recuperação secreta?',
    sheetP1:
      'Uma frase de recuperação secreta (também chamada mnemônica) é um conjunto de palavras que permite acessar e controlar sua carteira de criptomoedas. Você precisa dela para migrar sua carteira para MetaMask.',
    sheetListTitle: 'Qualquer pessoa com sua frase de recuperação secreta pode:',
    sheetL1: 'Levar todos os seus fundos',
    sheetL2: 'Confirmar transações',
    sheetL3: 'Alterar suas informações de login',
    gotIt: 'Entendi'
  },
  trust: {
    headerTitle: 'Carteira multicripto',
    walletName: 'Nome da carteira',
    defaultWalletName: 'Carteira principal 1',
    mnemonicLabel: 'Frase de recuperação',
    tips: 'Geralmente 12 palavras (às vezes 18 ou 24), separadas por um único espaço',
    invalidMnemonic: 'Frase de recuperação inválida'
  },
  okx: {
    title: 'Insira frase de recuperação ou chave privada',
    placeholder: 'Se importar com uma frase de recuperação, separe cada palavra com um espaço'
  }
};
